export class InviteAlreadyPhoneNumber extends Error {
  public constructor() {
    super()

    this.message = 'invitePage.inviteErrors.alreadyPhoneNumber'
  }
}
